import { LogIn } from 'lucide-react'
import { useState } from 'react'

import { TestUserPickerDialog } from '@/components/test-user-picker-dialog'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/providers'
import { isPermitted, Permissions } from '@/utils/permission-manager'

type LoginAsEpilotUserProps = {
  orgId: string
  orgName?: string | null
  disabled?: boolean
}

/**
 * Quick action: log into 360 as the org's epilot test user. Same flow as
 * "Login as User" in the organizations table: the picker finds the
 * testuser.epilot.cloud accounts, then the usual consent dialog follows.
 */
export const LoginAsEpilotUser = ({
  orgId,
  orgName,
  disabled
}: LoginAsEpilotUserProps) => {
  const { userData } = useAuth()
  const [open, setOpen] = useState(false)

  if (!isPermitted(Permissions.LOGIN_AS, userData)) return null

  return (
    <>
      <Button disabled={disabled} onClick={() => setOpen(true)} size="sm">
        <LogIn className="mr-2 h-4 w-4" />
        Login as epilot user
      </Button>
      <TestUserPickerDialog
        onOpenChange={setOpen}
        open={open}
        orgId={orgId}
        orgName={orgName ?? undefined}
      />
    </>
  )
}
